export enum ProductCategory {
    TSHIRTS = 'T-Shirts',
    BOTTLES = 'Bottles',
    CAPS = 'Caps',
    MUGS = 'Mugs',
    RESINKEYCHAIN = 'Resin Keychain',
    TRENDINGPRODUCTS = 'Trending Products'
}
